
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabRT(): TemplateResult<fitmentTableTabRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('div', {
        'className': 'cm_fitment-table__tab',
        'key': '0'
    }, _createElement('span', { 'className': 'tab-title' }, 'Fitments'), _createElement('svg', { 'className': 'accordion-icon arrow down' }, _createElement('use', { 'xlinkHref': '#icon-v-down' }))) : null;
}
        export const componentNames = []